/* eslint-disable */
import $ from 'jquery'
window.$ = window.jQuery = $

import Vue from 'vue'
import ElementUI from 'element-ui'
import Notify from 'vue-notifyjs'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import OnePagePlugin from '@/plugins/OnePagePlugin'
import GlobalComponents from '@/globalComponents'
import vBPopover from 'bootstrap-vue/es/directives/popover/popover'

import 'element-ui/lib/theme-chalk/index.css'
import 'vue-notifyjs/themes/default.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/scss/app.scss'

Vue.config.productionTip = false
Vue.directive('b-popover', vBPopover)
Vue.use(OnePagePlugin, {
  containerId: '#simulation-content',
  sectionClass: 'simulation-page-form'
})
Vue.use(GlobalComponents)
Vue.use(ElementUI)
Vue.use(Notify)
// Vue.use(Vue2TouchEvents)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

// Google Tag Manager
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-K4LHF68');
